import 'jquery-smooth-scroll'
import 'jquery.easing'
import { isMobile } from "./is-mobile";
jQuery(function ($) {
  $(".modal-animation").on("hidden.bs.modal", function () {
    const memory = $(this).html();
    $(this).html(memory);
  });


  $(document).on("click", ".modal a[href^='#']", function (e) {
    const href = $(this).attr("href");
    if (!href || href === "#") return;

    e.preventDefault();
    e.stopPropagation();

    const $modal = $(this).closest(".modal");

    $modal.one("hidden.bs.modal", function () {
      $.smoothScroll({
        scrollTarget: href,
        offset: isMobile() ? -40 : -98,
      });
    });

    $modal.modal("hide");
  });

});
